import { PKCE } from '@/utils/PKCE'
import { generateUUID } from '@/utils/uuid'

import { VkAuthSuccessCallback } from '@/services/vk/types'

import * as VKID from '@vkid/sdk'

export class VkAuthService {
  private static instance: VkAuthService
  private codeVerifier: string | null = null
  private appId: string | null = null
  private redirectUrl: string | null = null
  private isInitialized = false

  static getInstance(): VkAuthService {
    if (!VkAuthService.instance) {
      VkAuthService.instance = new VkAuthService()
    }
    return VkAuthService.instance
  }

  async init(appId: string, redirectUrl: string) {
    if (this.isInitialized) return

    this.appId = appId
    this.redirectUrl = redirectUrl
    this.codeVerifier = await PKCE.generateCodeVerifier()

    const codeChallenge = await PKCE.generateCodeChallenge(this.codeVerifier)
    const state = generateUUID()

    VKID.Config.init({
      app: Number(appId),
      redirectUrl,
      responseMode: VKID.ConfigResponseMode.Callback,
      codeChallenge,
      state,
      scope: 'vkid.personal_info phone',
    })

    this.isInitialized = true
  }

  initOneTap(successCallback: VkAuthSuccessCallback, container?: HTMLElement) {
    if (!container) return

    const oneTap = new VKID.OneTap()

    oneTap
      .render({ container })
      .on(VKID.WidgetEvents.ERROR, this.onError)
      .on(
        VKID.OneTapInternalEvents.LOGIN_SUCCESS,
        async (response: VKID.AuthResponse) => {
          await this.onLoginSuccess(response, successCallback)
        },
      )
  }

  initFloatingOneTap(successCallback: VkAuthSuccessCallback) {
    const floatingOneTap = new VKID.FloatingOneTap()

    floatingOneTap
      .render({ appName: 'FARFOR' })
      .on(VKID.WidgetEvents.ERROR, this.onError)
      .on(
        VKID.FloatingOneTapInternalEvents.LOGIN_SUCCESS,
        async (response: VKID.AuthResponse) => {
          await this.onLoginSuccess(response, successCallback)
        },
      )
  }

  private async onLoginSuccess(
    response: VKID.AuthResponse,
    successCallback: VkAuthSuccessCallback,
  ) {
    try {
      if (typeof successCallback !== 'function') return

      const { code, device_id, state } = response

      successCallback({
        code,
        device_id,
        state,
        code_verifier: this.codeVerifier || '',
        client_id: this.appId || '',
        redirect_uri: this.redirectUrl || '',
      })
    } catch (error) {
      this.onError(error)
    }
  }

  private onError(error: any) {
    console.log('vk: onError: ', error)
  }
}
